import styled from '@emotion/styled';
import { Divider, MenuList, MenuItem as MuiMenuItem } from '@mui/material';

export const StyledMenuList = styled(MenuList)`
    padding: 0;

    &:focus {
        outline: none;
    }
`;

export const StyledMenuDivider = styled(Divider)`
    margin: 1rem 0;
`;

export const MenuTitleContainer = styled(MuiMenuItem)`
    border-radius: 8px;
    padding: 6px;

    &:hover,
    &:focus {
        background-color: #fff;
    }
`;

export const MenuDateText = styled('p')`
    font-size: 12px;
    color: ${({ theme }) => theme.colors.black[600]};
    margin-top: 4px;
    margin-left: 8px;
`;

export const MenuOptionsButtonWrapper = styled.div<{ gap?: number }>`
    position: absolute;
    right: 16px;
    top: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 2;
    ${({ gap }) => gap && `gap: ${gap}px;`}
`;
